module.exports = {

  // Dev
  API_URL: 'https://demo-ttqn.e-gov.com.vn/api',
  REDIRECT_URL: 'https://demo-ttqn.e-gov.com.vn',
  API_URL_AUTH: 'https://demo-ttqn.e-gov.com.vn/api',

  // Live
  // API_URL: 'https://csdlthanhtra.danang.gov.vn/thanh-tra-api',
  // REDIRECT_URL: 'https://csdlthanhtra.danang.gov.vn',
  // API_URL_AUTH: 'https://csdlthanhtra.danang.gov.vn/api',

  // PROD_API_URL: 'https://csdlthanhtra.danang.gov.vn/api',
  // API_SSO_URL:'https://csdlthanhtra.danang.gov.vn/cas/token',
  // STAGING_API_URL: 'http://csdlthanhtra.danang.gov.vn:8089/api',
  // ERROR_TRACKER_URL: 'http://tracker.thanhtratp.greenglobal.vn:9836',
  FILE_ENV: 'live'

}



// WEBPACK FOOTER //
// ./env/production.js